import { Link } from "react-router-dom";
import { MapPin, Calendar, Briefcase, IndianRupee } from "lucide-react";
import VerifiedBadge from "./VerifiedBadge";
import StarRating from "./StarRating";

export default function JobCard({ job, application }) {
  return (
    <Link to={`/job/${job.id}`} className="card-flat block group" data-testid={`job-card-${job.id}`}>
      <div className="flex items-start justify-between gap-3">
        <span className="label-eyebrow text-muted-foreground">
          {job.opportunity_type === "event_staffing" ? "Event Staffing" : "Freelance"}
        </span>
        <span className="text-xs px-2.5 py-1 rounded-full font-mono bg-brand-tint text-brand">{job.specialization}</span>
      </div>
      <h3 className="mt-3 font-display text-xl tracking-tight group-hover:underline decoration-brand underline-offset-4 flex items-center gap-1.5">
        <span className="line-clamp-1">{job.title}</span>
        {job.poster_verified && <VerifiedBadge size={16} />}
      </h3>
      {job.posted_by_username && (
        <div className="flex items-center gap-1.5 mt-1">
          {job.posted_by_avatar
            ? <img src={job.posted_by_avatar} alt="" className="w-4 h-4 rounded-full object-cover" />
            : <div className="w-4 h-4 rounded-full bg-brand-tint text-brand grid place-items-center text-[8px] font-bold">{job.posted_by_username[0]}</div>
          }
          <p className="text-xs text-muted-foreground">@{job.posted_by_username}</p>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-3 text-xs text-muted-foreground">
        {job.location && <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{job.location}</span>}
        {job.event_date && <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{new Date(job.event_date).toLocaleDateString()}</span>}
        {job.distance_km != null && <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{job.distance_km} km</span>}
      </div>
      {job.poster_rating && (
        <div className="mt-2">
          <StarRating rating={job.poster_rating} count={job.poster_rating_count} size="sm" />
        </div>
      )}
      <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
        <div>
          {application?.fine_amount > 0 ? (
            <div className="flex items-baseline gap-1.5">
              <span className="text-xs text-muted-foreground line-through">₹{job.payment}</span>
              <span className="font-display text-2xl font-black inline-flex items-center text-foreground"><IndianRupee className="w-4 h-4" />{Math.max(0, job.payment - application.fine_amount)}</span>
            </div>
          ) : (
            <span className="font-display text-2xl font-black inline-flex items-center text-foreground"><IndianRupee className="w-4 h-4" />{job.payment}</span>
          )}
          {application && (
            <span className={`block text-[10px] mt-0.5 font-medium ${application.payment_paid ? "text-emerald-500" : "text-muted-foreground"}`}>
              {application.payment_paid ? "Paid" : "Payment pending"}
            </span>
          )}
        </div>
        <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
          <Briefcase className="w-3.5 h-3.5" />
          {job.confirmed_count || 0}/{job.total_slots} slot{job.total_slots > 1 ? "s" : ""}
          {job.remaining_slots === 0 && <span className="text-red-500 font-medium ml-1">Full</span>}
          {job.remaining_slots > 0 && <span className="text-emerald-500 font-medium ml-1">({job.remaining_slots} left)</span>}
        </span>
      </div>
    </Link>
  );
}
